import { render, staticRenderFns } from "./articellist.vue?vue&type=template&id=c081bf8e&scoped=true"
import script from "./articellist.vue?vue&type=script&lang=js"
export * from "./articellist.vue?vue&type=script&lang=js"
import style0 from "./articellist.vue?vue&type=style&index=0&id=c081bf8e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c081bf8e",
  null
  
)

export default component.exports